import React from 'react';
import {
  Select,
  SelectTrigger,
  SelectContent,
  SelectItem,
  SelectValue,
} from '@features/ui';
import { TOption } from '@src/types';

interface CountrySelectProps {
  value?: string;
  placeholder?: string;
  onChange: (value: string) => void;
  countryOptions: TOption[];
}

export const CountrySelect: React.FC<CountrySelectProps> = ({
  value,
  onChange,
  placeholder,
  countryOptions,
}) => {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger>
        <SelectValue placeholder={placeholder ?? 'Select a country'} />
      </SelectTrigger>
      <SelectContent>
        {countryOptions.map(({ value, label }) => (
          <SelectItem key={value} value={value}>
            {label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
